import { clearAuthStorage } from "@/config/authConfig";
import { MenuItemType } from "@/enums/MenuItemType";
import { routes } from "@/helpers";
import { generateMenuItems } from "@/helpers/generateMenuItems";
import { useAllRights } from "@/hooks";
import { IViperMenuItem } from "@/interfaces/IViperMenuItem";
import { useUserContext } from "@/providers";
import { useMsal } from "@azure/msal-react";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import {
  faAddressCard,
  faRightFromBracket,
  faUser,
  faUserSlash,
} from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Menu, MenuProps } from "antd";
import { useIntl } from "react-intl";

export const UserMenu = () => {
  const { instance } = useMsal();
  const intl = useIntl();
  const { adminRights } = useAllRights();
  const { isImpersonating, resetImpersonation, userDisplayName } =
    useUserContext();

  const user = instance.getActiveAccount();
  const logOut = (): Promise<void> => {
    clearAuthStorage();
    return instance.logoutRedirect();
  };

  const handleMenuAction: MenuProps["onClick"] = (e) => {
    switch (e.key) {
      case "user:clearImpersonation":
        resetImpersonation();
        break;
      case "user:signOut":
        logOut();
        break;
      default:
        break;
    }
  };

  const getUserId = (): string => {
    const userId = user?.idTokenClaims?.oid;

    return userId ?? "";
  };

  const items: IViperMenuItem[] = [
    {
      key: "user",
      type: MenuItemType.Parent,
      title: userDisplayName,
      icon: <FontAwesomeIcon icon={faUser as IconProp} />,
      children: [
        {
          key: "user:profile",
          type: MenuItemType.Item,
          visible: adminRights.canViewUsers,
          title: intl.formatMessage({ id: "profile.profileText" }),
          icon: <FontAwesomeIcon icon={faAddressCard as IconProp} />,
          url: routes.admin.users.get(getUserId()),
        },
        {
          key: "user:clearImpersonation",
          type: MenuItemType.Item,
          title: intl.formatMessage({ id: "profile.clearImpersonation" }),
          visible: isImpersonating,
          icon: <FontAwesomeIcon icon={faUserSlash as IconProp} />,
        },
        {
          key: "user:signOut",
          type: MenuItemType.Item,
          title: intl.formatMessage({ id: "navbar.signOut" }),
          icon: <FontAwesomeIcon icon={faRightFromBracket as IconProp} />,
        },
      ],
    },
  ];

  const onClick: MenuProps["onClick"] = (e) => {
    handleMenuAction(e);
  };

  return (
    <Menu
      data-test-id="user-menu"
      onClick={onClick}
      selectedKeys={[]}
      mode="horizontal"
      items={generateMenuItems(items)}
      disabledOverflow={true}
    />
  );
};
